module.exports = __webpack_public_path__ + "static/media/sex-and-food.30837907.jpg";